'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactFulcrum = require('@upgrowth/react-fulcrum');

var _lodash = require('lodash');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var supportedProps = [// Html
'disabled']; // export default ({name, path, value, onChange, type, ...props}: Props) => {

exports.default = function (_ref) {
  var name = _ref.name,
      type = _ref.type,
      context = _ref.context;
  var value = context.value,
      path = context.path,
      labels = context.labels,
      _onChange = context.onChange;
  var description = type.description,
      label = type.label,
      _type$defaultValue = type.defaultValue,
      defaultValue = _type$defaultValue === undefined ? false : _type$defaultValue;
  return React.createElement('div', {
    className: 'BooleanEditor'
  }, React.createElement(_reactFulcrum.Switch, (0, _extends3.default)({
    name: name
  }, (0, _lodash.pick)(type, supportedProps), {
    label: label,
    value: value === undefined ? defaultValue : value,
    onChange: function onChange(value) {
      return _onChange(path, value);
    }
  })));
};